var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitiesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4 26.88C96.9472 26.88 112 40.9248 112 58.24C112 75.5552 96.9472 89.6 78.4 89.6H33.6C15.0528 89.6 0 75.5552 0 58.24C0 40.9248 15.0528 26.88 33.6 26.88H78.4ZM81.8496 45.7856C80.528 46.9952 79.7888 48.6752 79.7888 50.4C79.7888 52.1248 80.528 53.8048 81.8496 55.0144C83.1712 56.2464 84.9408 56.9408 86.8 56.9408C88.6592 56.9408 90.4288 56.2464 91.7504 55.0144C93.072 53.8048 93.7888 52.1248 93.7888 50.4C93.7888 48.6752 93.072 46.9952 91.7504 45.7856C90.4288 44.5536 88.6592 43.8592 86.8 43.8592C84.9408 43.8592 83.1712 44.5536 81.8496 45.7856ZM70.6496 70.6944C71.9712 71.9264 73.7408 72.6208 75.6 72.6208C77.4592 72.6208 79.2288 71.9264 80.5504 70.6944C81.872 69.4848 82.5888 67.8048 82.5888 66.08C82.5888 64.3552 81.872 62.6752 80.5504 61.4656C79.2288 60.2336 77.4592 59.5392 75.6 59.5392C73.7408 59.5392 71.9712 60.2336 70.6496 61.4656C69.328 62.6752 68.5888 64.3552 68.5888 66.08C68.5888 67.8048 69.328 69.4848 70.6496 70.6944ZM29.3888 54.32H23.7888C21.4816 54.32 19.6 56.0672 19.6 58.24C19.6 60.4128 21.4816 62.16 23.7888 62.16H29.3888V67.3792C29.3888 69.552 31.2704 71.2992 33.6 71.2992C35.9296 71.2992 37.7888 69.552 37.7888 67.3792V62.16H43.3888C45.7184 62.16 47.6 60.4128 47.6 58.24C47.6 56.0672 45.7184 54.32 43.3888 54.32H37.7888V49.1008C37.7888 46.928 35.9296 45.1808 33.6 45.1808C31.2704 45.1808 29.3888 46.928 29.3888 49.1008V54.32Z",
    fill: "#1C1D1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesFilled);
export default __webpack_public_path__ + "static/media/activities_filled.c4056424a52ca572413828a54decdd8d.svg";
export { ForwardRef as ReactComponent };